import { render, staticRenderFns } from "./ForgotPasswordVerification.vue?vue&type=template&id=69221cfe&scoped=true&"
import script from "./ForgotPasswordVerification.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordVerification.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordVerification.vue?vue&type=style&index=0&id=69221cfe&prod&scoped=true&lang=css&"
import style1 from "./ForgotPasswordVerification.vue?vue&type=style&index=1&id=69221cfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69221cfe",
  null
  
)

export default component.exports